import React, { useState } from "react";
import api from "../../api";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { setAuthorized } from "../../store/userSelector";
import { Alert, Button, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./register.scss";
import Head from "../../elements/head/head";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

const Box_Card = styled(Card)(({ theme }) => ({
  backgroundColor: theme.color.main,
  margin: "auto",
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
  width: "200px",
}));

const But = styled(Button)(({ theme }) => ({
  backgroundColor: theme.color.banner,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username_error, setUsername_error] = useState(false);
  const [username_helperText, setUsername_helperText] = useState("");

  const [first_name_error, setFirst_name_error] = useState(false);
  const [first_name_helperText, setFirst_helperText] = useState("");

  const [last_name_error, setLast_name_error] = useState(false);
  const [last_name_helperText, setLast_name_helperText] = useState("");

  const [email_error, setEmail_error] = useState(false);
  const [email_helperText, setEmail_helperText] = useState("");

  const [password_error, setPassword_error] = useState(false);
  const [password_helperText, setPassword_helperText] = useState("");

  const [username, setUserName] = useState(null);
  const [first_name, setFirst_name] = useState(null);
  const [last_name, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [alert, setAlert] = useState(false);
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };
  const registerFunc = () => {
    setDisabled(true);
    if (first_name && password && last_name && email && username) {
      if (email && validateEmail(email)) {
        setAlert(null);
        api
          .registerUser(username, password, first_name, last_name, email)
          .then((response) => {
            dispatch(setAuthorized(response.data.token));
            navigate("/lk");
          })

          .catch((error) => {
            if (error.response.data.username) {
              setUsername_error(true);
              setUsername_helperText(error.response.data.username);
            } else {
              setUsername_error(false);
              setUsername_helperText("");
            }
            if (error.response.data.first_name) {
              setFirst_name_error(true);
              setFirst_helperText(error.response.data.first_name);
            } else {
              setFirst_name_error(false);
              setFirst_helperText("");
            }

            if (error.response.data.last_name) {
              setLast_name_error(true);
              setLast_name_helperText(error.response.data.last_name);
            } else {
              setLast_name_error(false);
              setLast_name_helperText("");
            }

            if (error.response.data.email) {
              setEmail_error(true);
              setEmail_helperText(error.response.data.email);
            } else {
              setEmail_error(false);
              setEmail_helperText("");
            }

            if (error.response.data.password) {
              setPassword_error(true);
              setPassword_helperText(error.response.data.password);
            } else {
              setPassword_error(false);
              setPassword_helperText("");
            }
          });
      } else {
        setAlert({
          status: "warning",
          text: "Пожалуйста введите валидный email.",
        });
      }
    } else {
      setAlert({ status: "warning", text: "Пожалуйста заполните все поля." });
    }
    setDisabled(false);
  };

  return (
    <div className="main_">
      <Grid container spacing={2}>
        <Grid size={12}>
          <Head />
        </Grid>
        <Grid size={12}>
          <Box_Card>
            <Item>
              <h6>Регистрация</h6>
            </Item>
            <Item>
              <TextField
                disabled={disabled}
                value={username}
                onChange={(e) => setUserName(e.target.value)}
                label="Логин"
                variant="outlined"
                error={username_error}
                helperText={username_helperText}
              />
            </Item>
            <Item>
              <TextField
                disabled={disabled}
                value={password}
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                label="Пароль"
                variant="outlined"
                error={password_error}
                helperText={password_helperText}
              />
            </Item>
            <Item>
              <TextField
                value={first_name}
                disabled={disabled}
                onChange={(e) => setFirst_name(e.target.value)}
                label="Имя"
                variant="outlined"
                error={first_name_error}
                helperText={first_name_helperText}
              />
            </Item>
            <Item>
              <TextField
                value={last_name}
                disabled={disabled}
                onChange={(e) => setLastName(e.target.value)}
                label="Фамилия"
                variant="outlined"
                error={last_name_error}
                helperText={last_name_helperText}
              />
            </Item>
            <Item>
              <TextField
                disabled={disabled}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label="Емаил"
                variant="outlined"
                type="email"
                error={email_error}
                helperText={email_helperText}
              />
            </Item>
            <Item>
              <But
                onClick={registerFunc}
                disabled={disabled}
                variant="outlined"
              >
                Зарегистрироваться
              </But>
            </Item>
            {alert && (
              <Alert variant="outlined" severity={alert.status}>
                {alert.text}
              </Alert>
            )}
          </Box_Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Register;
